import React from 'react';
import { BedDouble, ZapOff, BookOpen, Shirt } from 'lucide-react';
export function SymptomsSection() {
  const symptoms = [{
    icon: <BedDouble className="w-6 h-6 text-background" data-id="element-273" />,
    text: <span data-id="element-274">
          Te despertás <strong className="text-navy" data-id="element-275">más cansado</strong> de lo
          que te acostaste.
        </span>
  }, {
    icon: <ZapOff className="w-6 h-6 text-background" data-id="element-276" />,
    text: <span data-id="element-277">
          A las 3 de la tarde tu{' '}
          <strong className="text-navy" data-id="element-278">cerebro "se apaga"</strong> y necesitás
          azúcar o café para seguir.
        </span>
  }, {
    icon: <BookOpen className="w-6 h-6 text-background" data-id="element-279" />,
    text: <span data-id="element-280">
          Leés la misma frase tres veces y{' '}
          <strong className="text-navy" data-id="element-281">no lográs concentrarte</strong>.
        </span>
  }, {
    icon: <Shirt className="w-6 h-6 text-background" data-id="element-282" />,
    text: <span data-id="element-283">
          Tu <strong className="text-navy" data-id="element-284">ropa te queda apretada</strong>,
          aunque sentís que "no comés tanto".
        </span>
  }];
  return <section className="py-4 md:py-14 px-6 bg-background" data-id="element-285">
      <div className="max-w-5xl mx-auto" data-id="element-286">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-navy mb-8 md:mb-16" data-id="element-287">
          ¿Te resulta familiar?
        </h2>

        <div className="grid md:grid-cols-2 gap-4 md:gap-8 mb-8 md:mb-16" data-id="element-288">
          {symptoms.map((symptom, index) => <div key={index} className="flex items-start gap-4 p-6 bg-white rounded-xl shadow-sm border border-navy/5 hover:border-accent/30 transition-colors" data-id="element-289">
              <div className="flex-shrink-0 w-12 h-12 bg-accent rounded-lg flex items-center justify-center shadow-md" data-id="element-290">
                {symptom.icon}
              </div>
              <p className="text-lg text-navy/80 font-medium pt-2" data-id="element-291">
                {symptom.text}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-292">
          <p className="inline-block px-8 py-4 bg-navy text-amber font-serif text-xl md:text-2xl italic rounded-full shadow-lg" data-id="element-293">
            "No te falta <strong data-id="element-294">voluntad</strong>. Te falta una{' '}
            <strong data-id="element-295">señal biológica limpia</strong>."
          </p>
        </div>
      </div>
    </section>;
}